(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-swatches"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs-swatches')) {
    class ProductTabsSwatches extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.activate(i));
          tab.addEventListener('keydown', (e) => {
            if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) return;
            e.preventDefault();
            let n = i;
            if (e.key === 'ArrowRight') n = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') n = 0;
            if (e.key === 'End') n = this.tabs.length - 1;
            this.activate(n);
            this.tabs[n].focus();
          });
        });

        this.panels.forEach((panel) => this.initCarousel(panel));

        this.addEventListener('click', (e) => {
          const swatch = e.target.closest('[data-swatch]');
          if (swatch) { e.preventDefault(); this.selectSwatch(swatch); return; }
          const add = e.target.closest('[data-quick-add]');
          if (add) { e.preventDefault(); this.quickAdd(add); }
        });

        // Theme-Editor: Block auswählen -> passenden Tab öffnen
        this.onBlockSelect = (e) => {
          if (e.detail.sectionId !== this.dataset.sectionId) return;
          const i = this.tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
          if (i > -1) this.activate(i);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      activate(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on);
          tab.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((panel, i) => {
          const on = i === index;
          panel.hidden = !on;
          panel.classList.toggle('is-active', on);
          if (on) panel._ptsUpdate && panel._ptsUpdate();
        });
      }

      initCarousel(panel) {
        const track = panel.querySelector('[data-track]');
        const prev = panel.querySelector('[data-prev]');
        const next = panel.querySelector('[data-next]');
        const bar = panel.querySelector('[data-progress]');
        if (!track) return;

        const step = () => {
          const slide = track.querySelector('.pts__slide');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
        };

        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max - 2;
          if (bar) {
            const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
            bar.style.width = Math.min(ratio, 1) * 100 + '%';
            const pos = max > 0 ? track.scrollLeft / max : 0;
            bar.style.transform = 'translateX(' + pos * (1 / Math.min(ratio, 1) - 1) * 100 + '%)';
          }
        };

        prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
        window.addEventListener('resize', update);
        panel._ptsUpdate = update;
        update();
      }

      selectSwatch(swatch) {
        const card = swatch.closest('[data-product-card]');
        if (!card) return;

        card.querySelectorAll('[data-swatch]').forEach((s) => {
          const on = s === swatch;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-checked', on);
        });

        // Bild wechseln (vorladen, dann tauschen)
        const img = card.querySelector('[data-card-image]');
        const src = swatch.dataset.imageSrc;
        if (img && src && img.getAttribute('src') !== src) {
          img.classList.add('is-loading');
          const pre = new Image();
          pre.srcset = swatch.dataset.imageSrcset || '';
          pre.sizes = img.sizes;
          pre.src = src;
          const swap = () => {
            img.srcset = swatch.dataset.imageSrcset || '';
            img.src = src;
            if (swatch.dataset.imageAlt) img.alt = swatch.dataset.imageAlt;
            img.classList.remove('is-loading');
          };
          pre.decode ? pre.decode().then(swap).catch(swap) : (pre.onload = swap);
        }

        // Links auf Variante setzen
        if (swatch.dataset.url) card.querySelectorAll('[data-card-link]').forEach((a) => (a.href = swatch.dataset.url));

        // Preis aktualisieren
        const price = card.querySelector('[data-price]');
        const compare = card.querySelector('[data-compare]');
        if (price && swatch.dataset.price) price.innerHTML = swatch.dataset.price;
        if (compare) {
          compare.innerHTML = swatch.dataset.compare || '';
          compare.hidden = !swatch.dataset.compare;
        }

        // Quick-Add auf Variante setzen
        const add = card.querySelector('[data-quick-add]');
        if (add) {
          add.dataset.variantId = swatch.dataset.variantId;
          add.disabled = swatch.dataset.available !== 'true';
          add.classList.remove('is-added');
        }
      }

      async quickAdd(button) {
        const id = button.dataset.variantId;
        if (!id) return;
        button.classList.add('is-busy');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
          if (!res.ok) throw await res.json();
          const data = await res.json();

          if (this.dataset.quickAddBehavior === 'cart_page') {
            window.location.href = root + 'cart';
            return;
          }
          button.classList.add('is-added');
          setTimeout(() => button.classList.remove('is-added'), 2000);
          // Event für Cart-Drawer / Cart-Count des Themes
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { items: data.items, source: 'product-tabs-swatches' } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (err) {
          console.error('[product-tabs-swatches]', err);
          alert((err && err.description) || 'Produkt konnte nicht hinzugefügt werden.');
        } finally {
          button.classList.remove('is-busy');
        }
      }
    }
    customElements.define('product-tabs-swatches', ProductTabsSwatches);
  }

  } catch(e) { console.error(e); }
})();
})();
